var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23.485px",
    height: "21.388px",
    viewBox: "0 0 23.485 21.388",
    enableBackground: "new 0 0 23.485 21.388",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#395754",
    d: "M19.625,21.388H3.86c-2.129,0-3.86-1.732-3.86-3.861V5.52c0-2.124,1.731-3.855,3.86-3.855h15.765 c2.128,0,3.86,1.731,3.86,3.855v12.007C23.485,19.656,21.753,21.388,19.625,21.388 M3.86,3.211c-1.275,0-2.313,1.034-2.313,2.309 v12.007c0,1.276,1.038,2.313,2.313,2.313h15.765c1.275,0,2.313-1.037,2.313-2.313V5.52c0-1.274-1.037-2.309-2.313-2.309H3.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395754",
    d: "M6.365,5.328c-0.426,0-0.773-0.347-0.773-0.774V0.875c0-0.426,0.348-0.773,0.773-0.773 s0.773,0.347,0.773,0.773v3.679C7.139,4.98,6.791,5.328,6.365,5.328"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#395754",
    d: "M17.708,5.226c-0.426,0-0.773-0.347-0.773-0.773V0.773C16.935,0.347,17.282,0,17.708,0 s0.774,0.347,0.774,0.773v3.679C18.482,4.879,18.134,5.226,17.708,5.226"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApnt);
export default __webpack_public_path__ + "static/media/apnt.bd0d117ac0d2f1cf03dd87f3075a388c.svg";
export { ForwardRef as ReactComponent };